import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { registerStickyActions } from 'utils/hooks/useStickyActions'

const StickyFooter = (props) => {
    const { children, className, stickyClass, ...rest } = props

    const [isSticky, setIsSticky] = useState(false)
    const ref = useRef()

    useEffect(() => {
        const cachedRef = ref.current
        const observer = new IntersectionObserver(
            ([e]) => setIsSticky(e.intersectionRatio < 1),
            {
                threshold: [1],
            }
        )

        observer.observe(cachedRef)

        // Publish this bar's measured height (--mobile-sticky-actions-height)
        // so floating utility widgets can stay clear of the page actions.
        const unregister = registerStickyActions(cachedRef)

        return function () {
            observer.unobserve(cachedRef)
            unregister()
        }
    }, [])

    return (
        <div
            className={classNames(
                // z-20: sticky page actions sit above floating widgets (z-10)
                // and below drawers/dialogs (z-30) — see useStickyActions.js.
                'sticky -bottom-1 z-20',
                className,
                isSticky && stickyClass
            )}
            ref={ref}
            {...rest}
        >
            {children}
        </div>
    )
}

StickyFooter.propTypes = {
    stickyClass: PropTypes.string,
}

export default StickyFooter
